export const hats = value => dispatch => dispatch({ type: 'HATS_AVAILABLE', value });
